<div ngbDropdown #dropdown='ngbDropdown'
  [autoClose]="'outside'"
  (openChange)="openChangeHandler($event)"
  data-cy="multi-selection-dropdown">
  <button ngbDropdownToggle
    class="dropdown-button"
    data-cy="dropdown-toggle-button">
    <div class="dropdown-button-text">
      <span data-cy="dropdown-toggle-button-placeholder">{{state.dropdownButtonPlaceholder}}</span>
    </div>

        <span [ngClass]="{
                'iwp-icon-gen_arrow_down': !dropdown.isOpen(),
                'iwp-icon-gen_arrow_up open': dropdown.isOpen()
            }"
      class="dropdown-toggle-button-arrow"
    data-cy="dropdown-toggle-button-arrow"></span>
  </button>
  <div ngbDropdownMenu class="dropdown-menu-wrapper">
    @for (option of state.dropdownData; track option) {
      <button ngbDropdownItem
        (click)="checkDropdownItemHandler(option)"
        class="dropdown-item"
        (keydown.enter)=handleManuallyCloseDropdown($event)
        [ngClass]="{'item-checked': option.checked}"
        [attr.data-cy]="dropdownItemDataCy(option.name, 'button')">
        <div class="dropdown-item-button-wrapper">
          <input type="checkbox"
            [attr.data-cy]="dropdownItemDataCy(option.name, 'checkbox')"
            [(ngModel)]="option.checked"
            (keydown.enter)=handleManuallyCloseDropdown($event)>
          <span [attr.data-cy]="dropdownItemDataCy(option.name, 'text')">{{ option.name }}</span>
        </div>
      </button>
    }
  </div>
</div>
@if (spinnerObservable | async) {
  <div class="spinner-container">
    <app-loading-spinner class="button-spinner"></app-loading-spinner>
  </div>
}
